import { Land } from "./land";
import { clonePackung, Packung, PackungCmd } from "./packung";
import { Nutzung } from "@app/shared/classes/nutzung";

export interface Praeparat {
  nutzung                          : Nutzung;
  spezies                          : string;
  zulassungsLand                   : Land;
  zulassungsNr                     : string;
  name                             : string;
  zulassungsNrCh                   : string;
  anhang5                          : boolean;
  umgewidmet                       : boolean;
  auslaendischeZulassungTierart    : boolean;
  auslaendischeZulassungIndikation : boolean;
  bienen                           : boolean;
  immunologisch                    : boolean;
  hersteller                       : string;
  bestandteile                     : string;
  tierhalter                       : string;
  betaeubungsmittel                : boolean;
  packungen                        : Packung[];
}

export class PraeparatCmd {
  nutzung                          : Nutzung | null = null;
  spezies                          : string  | null = null;
  zulassungsLand                   : Land    | null = null;
  zulassungsNr                     : string  | null = null;
  name                             : string  | null = null;
  zulassungsNrCh                   : string  | null = null;
  anhang5                          : boolean | null = null;
  umgewidmet                       : boolean | null = null;
  bienen                           : boolean | null = null;
  immunologisch                    : boolean | null = null;
  hersteller                       : string  | null = null;
  bestandteile                     : string  | null = null;
  tierhalter                       : string  | null = null;
  packungen                        : PackungCmd[]   = [new PackungCmd()];

  public constructor(init?: Partial<PraeparatCmd>) {
    Object.assign(this, init);
  }
}

export function clonePraeparat(original?: Praeparat): PraeparatCmd {
  return new PraeparatCmd({
    nutzung        : original?.nutzung,
    spezies        : original?.spezies,
    zulassungsLand : original?.zulassungsLand,
    zulassungsNr   : original?.zulassungsNr,
    name           : original?.name,
    zulassungsNrCh : original?.zulassungsNrCh,
    anhang5        : original?.anhang5,
    umgewidmet     : original?.umgewidmet,
    bienen         : original?.bienen,
    immunologisch  : original?.immunologisch,
    hersteller     : original?.hersteller,
    bestandteile   : original?.bestandteile,
    tierhalter     : original?.tierhalter,
    packungen      : original?.packungen.map( it => clonePackung(it) )
  });
}
